import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const PodcastsIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="36"
    height="52"
    viewBox="0 0 36 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.9846 35.374C20.5728 35.374 22.9992 34.4034 24.7785 32.5432C26.5579 30.7638 27.5284 28.4183 27.4476 25.911V10.463C27.4476 5.20576 23.1609 1 17.9846 1C12.7274 1 8.52163 5.28664 8.52163 10.463V25.8302C8.44075 31.0874 12.7274 35.374 17.9846 35.374ZM11.2716 10.463C11.2716 6.82336 14.2641 3.8308 17.9037 3.8308C21.5433 3.8308 24.5359 6.82336 24.5359 10.463V25.911C24.5359 27.6904 23.8888 29.308 22.6756 30.6021C21.3816 31.8962 19.6831 32.6241 17.9037 32.6241C14.2641 32.6241 11.2716 29.6315 11.2716 25.9919V10.463Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M34.727 25.4256C34.727 24.6168 34.0799 23.9697 33.2711 23.9697C32.4623 23.9697 31.8153 24.6168 31.8153 25.4256C31.8153 33.1092 25.5875 39.3369 17.823 39.3369C10.1394 39.3369 3.91168 33.1092 3.91168 25.4256C3.91168 24.6168 3.26464 23.9697 2.45584 23.9697C1.64704 23.9697 1 24.6168 1 25.4256C1 34.1606 7.71304 41.3589 16.2863 42.0868V47.8293H10.6247C9.81592 47.8293 9.16888 48.4764 9.16888 49.2852C9.16888 50.094 9.81592 50.741 10.6247 50.741H24.7787C25.5875 50.741 26.2346 50.094 26.2346 49.2852C26.2346 48.4764 25.5875 47.8293 24.7787 47.8293H19.1171V42.0868C27.933 41.4398 34.727 34.2415 34.727 25.4256Z"
      fill={props.color ? props.color : colors.uguPurple}
      stroke={props.color ? props.color : colors.uguPurple}
    />
  </svg>
)
